<span class="badge badge-pedido-status badge-pedido-status-faturado">
    {{status.nome}}
</span>